<template>
	<div style="display: flex; flex-direction: column; flex-grow: 1">
		<v-form ref="form" style="flex-grow: 1">
			<v-row>
				<v-col>
					<v-text-field
						label="Name"
						:rules="nameRules"
						v-model="formInventory.Name"
					/>
				</v-col>
				<v-col>
					<v-select
						:disabled="this.$route.params.id != null"
						label="Entity"
						:items="entities"
						v-model="formInventory.EntityId"
						:rules="entityRules"
						item-text="Name"
						item-value="Id"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-select
						v-model="formInventory.StorageMode"
						:rules="storageRules"
						label="Storage Mode"
						:items="storageMode"
						item-text="text"
						item-value="value"
					></v-select>
				</v-col>
				<v-col>
					<v-select
						v-model="formInventory.Type"
						:rules="typeRules"
						label="Type"
						:items="type"
						item-text="text"
						item-value="value"
					></v-select>
				</v-col>
			</v-row>
			<v-row
				><v-col>
					<v-select
						v-model="formInventory.OnUpdate"
						:rules="updateRules"
						label="When updating existing records"
						:items="onUpdate"
						item-text="text"
						item-value="value"
					></v-select></v-col
				><v-col>
					<v-select
						v-model="formInventory.OnCreate"
						:rules="createRules"
						label="When creating new records"
						:items="onCreate"
						item-text="text"
						item-value="value"
					></v-select
				></v-col>
			</v-row>
			<v-row>
				<v-col cols="6">
					<v-text-field
						type="number"
						:rules="fieldsPerRowRules"
						:min="1"
						:max="2"
						label="Fields per row"
						v-model="formInventory.ColumnsPerRow"
					>
					</v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-checkbox
						v-if="false"
						v-model="formInventory.PreventDuplicateTag"
						label="Prevent Duplicate Tag"
					></v-checkbox>
					<v-checkbox
						v-if="false"
						v-model="formInventory.PreventDuplicateSN"
						label="Prevent Duplicate Sn"
					></v-checkbox>
					<v-checkbox
						v-if="false"
						v-model="formInventory.AllowUserToCreateCatalogs"
						label="Allow user to create Catalogs"
					></v-checkbox>
				</v-col>
				<v-col>
					<v-checkbox
						v-if="false"
						v-model="formInventory.AllowUserToCreateDepartments"
						label="Allow user to create Departments"
					></v-checkbox>
					<v-checkbox
						v-if="false"
						v-model="formInventory.AllowUserToCreateLocations"
						label="Allow user to create Locations"
					></v-checkbox>
					<v-checkbox
						v-if="false"
						v-model="formInventory.AllowUserToCreateNames"
						label="Allow user to create Names"
					></v-checkbox>
				</v-col>
			</v-row>
		</v-form>
		<div style="align-self: flex-end">
			<v-btn
				v-if="(canEdit && selectedForm) || (canAdd && !selectedForm)"
				class="primary"
				@click="submit()"
			>
				Submit
			</v-btn>
		</div>
	</div>
</template>
<script>
import { FormDetailsActions } from '../../../../store/actions';
import { FormDetailsGetters } from '../../../../store/getters';
import { InventoryFormStorageMode } from '../../../../enums/inventoryFormStorageMode';
import { InventoryFormTypes } from '../../../../enums/inventoryFormTypes';
import { InventoryFormOnCreate } from '../../../../enums/inventoryFormOnCreate';
import { InventoryFormOnUpdate } from '../../../../enums/inventoryFormOnUpdate';
import { mapGetters } from 'vuex';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';

export default {
	name: 'InventoryFormDetails',
	mixins: [permissionsMixin],
	data() {
		return {
			nameRules: [(v) => !!v || 'Name is required'],
			entityRules: [(v) => !!v || 'Entity is required'],
			storageRules: [
				(v) => v == 1 || v == 0 || 'Storage Mode is required',
			],
			typeRules: [(v) => !!v || 'Type is required'],
			updateRules: [
				(v) => !!v || 'When updating existing records is required',
			],
			createRules: [
				(v) => !!v || 'When creating new records is required',
			],
			fieldsPerRowRules: [
				(v) => v == 1 || v == 2 || 'The value must be 1 or 2',
			],
			storageMode: [
				{ value: InventoryFormStorageMode.Online, text: 'Online' },
				{
					value: InventoryFormStorageMode.Offline,
					text: 'Offline',
					disabled: true,
				},
			],
			type: [
				{ value: InventoryFormTypes.Inventory, text: 'Inventory' },
				{
					value: InventoryFormTypes.RemoteUser,
					text: 'Remote User',
					disabled: true,
				},
				{ value: InventoryFormTypes.SteadyState, text: 'Steady State' },
			],
			onCreate: [
				{
					value: InventoryFormOnCreate.CreateNew,
					text: 'Create new record even if primary key match exists',
				},
				{
					value: InventoryFormOnCreate.MergeByPk,
					text: 'Merge new record with existing record if primary key match exists',
				},
			],
			onUpdate: [
				{
					value: InventoryFormOnUpdate.OverwriteRecordDbId,
					text: 'Update based on record ID match',
				},
				{
					value: InventoryFormOnUpdate.OverwriteRecordPk,
					text: 'Update based on primary key match',
				},
				{
					value: InventoryFormOnUpdate.NewRecord,
					text: 'Create new record for each update',
				},
			],
		};
	},
	computed: {
		...mapGetters({
			entities: [FormDetailsGetters.ENTITIES],
			selectedForm: [FormDetailsGetters.SELECTEDFORM],
		}),
		formInventory() {
			return Object.assign({}, this.selectedForm);
		},
		canView() {
			return this.hasPermissions([Permissions.Tools.FormBuilder.View]);
		},
		canAdd() {
			return this.hasPermissions([Permissions.Tools.FormBuilder.Add]);
		},
		canEdit() {
			return this.hasPermissions([Permissions.Tools.FormBuilder.Edit]);
		},
	},
	// the form and the entity list are loaded and cleared by InventoryForm.vue, so that the toolbar
	// and the other tabs keep seeing the selected form after this tab is destroyed

	methods: {
		submit() {
			if (this.$refs.form.validate()) {
				if (this.formInventory.VisibleAllUsers == null)
					this.formInventory.VisibleAllUsers = false;
				if (this.formInventory.PreventDuplicateTag == null)
					this.formInventory.PreventDuplicateTag = false;
				if (this.formInventory.PreventDuplicateSN == null)
					this.formInventory.PreventDuplicateSN = false;
				if (this.formInventory.AllowUserToCreateCatalogs == null)
					this.formInventory.AllowUserToCreateCatalogs = false;
				if (this.formInventory.AllowUserToCreateDepartments == null)
					this.formInventory.AllowUserToCreateDepartments = false;
				if (this.formInventory.AllowUserToCreateLocations == null)
					this.formInventory.AllowUserToCreateLocations = false;
				if (this.formInventory.AllowUserToCreateNames == null)
					this.formInventory.AllowUserToCreateNames = false;
				if (this.$route.params.id) {
					this.$store
						.dispatch(
							FormDetailsActions.UPDATE_INVENTORYFORMS,
							this.formInventory
						)
						.then(() => {
							this.$router.push({ name: 'FormBuilder' });
						});
				} else {
					this.$store
						.dispatch(
							FormDetailsActions.INSERT_INVENTORYFORMS,
							this.formInventory
						)
						.then((success) => {
							if (!success) return;
							if (this.canEdit) {
								this.$router.push({
									name: 'EditInventoryForm',
									params: { id: this.selectedForm.Id },
								});
							}
							if (this.canAdd && !this.canEdit) {
								this.$router.push({
									name: 'FormBuilder',
								});
							}
						});
				}
			}
		},
	},
};
</script>
